import { createApi } from "@reduxjs/toolkit/query/react";
import { endPoints, urlKeys } from "../../api";
import { baseQuery } from "./baseQuery";
import { formatString } from "../../utils/urlFormatting";

export const usersQuery = createApi({
  baseQuery,
  reducerPath: "usersQueries",
  endpoints: (builder) => ({
    createUser: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.userManagement.create)}`,
        method: "POST",
        body: data,
      }),
    }),
    updateUser: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.userManagement.updateUser)}`,
        method: "PUT",
        body: data,
      }),
    }),
    getAllUser: builder.mutation<any, any>({
      query: ({
        from = 0,
        size = -1,
        value = "",
        sort_by = "",
        sort_order = "",
        is_audit = false,
        data,
      }) => ({
        url: `${formatString(
          endPoints.userManagement.getAllUser
        )}?from=${from}&size=${size}${
          value && `&value=${encodeURIComponent(value)}`
        }${sort_by && `&sort_by=${sort_by}`}${
          sort_order && `&sort_order=${sort_order}`
        }${`&is_audit=${is_audit}`}`,
        method: "POST",
        body: data,
      }),
    }),
    deleteUser: builder.mutation<any, any>({
      query: ({ email, data }) => ({
        url: `${formatString(endPoints.userManagement.deleteUser, {
          key: urlKeys.email,
          value: email,
        })}`,
        method: "DELETE",
        body: data,
      }),
    }),
    getEmailBasedUser: builder.query<any, any>({
      query: ({ email, role, permission }) => ({
        url: `${
          (formatString(endPoints.userManagement.emailBasedUser),
          {
            key: urlKeys.email,
            value: email,
          })
        }?permission=${permission}&role=${role}`,
        method: "GET",
      }),
    }),
    approveUser: builder.mutation<any, any>({
      query: ({ data, email }) => ({
        url: `${formatString(endPoints.userManagement.approve, {
          key: urlKeys.email,
          value: email,
        })}`,
        method: "PATCH",
        body: data,
      }),
    }),
    selectUser: builder.query<any, any>({
      query: ({ email, is_audit = false }) => ({
        url: `${formatString(endPoints.userManagement.select, {
          key: urlKeys.email,
          value: email,
        })}?is_audit=${is_audit}`,
        method: "GET",
      }),
    }),
    defaultRoleUpdate: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.userManagement.defaultUser)}`,
        method: "PATCH",
        body: data,
      }),
    }),
    changePassword: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.userManagement.changePassword)}`,
        method: "PATCH",
        body: data,
      }),
    }),
    getUserRoles: builder.query<any, void>({
      query: () => ({
        url: `${formatString(endPoints.userManagement.userRoles)}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateUserMutation,
  useUpdateUserMutation,
  useGetAllUserMutation,
  useDeleteUserMutation,
  useLazyGetEmailBasedUserQuery,
  useApproveUserMutation,
  useLazySelectUserQuery,
  useDefaultRoleUpdateMutation,
  useChangePasswordMutation,
  useLazyGetUserRolesQuery,
} = usersQuery;
